export default __webpack_public_path__ + "static/media/serpent-logo.94b320ae.png";